/* Keep desktop link columns expanded; use native details disclosure on phones. */
(() => {
  const breakpoint = window.matchMedia('(min-width: 750px)');
  function sync(root = document) {
    root.querySelectorAll('details[data-wf-collapse-mobile]').forEach(menu => {
      menu.open = breakpoint.matches;
    });
  }
  sync();
  breakpoint.addEventListener('change', () => sync());
  document.addEventListener('shopify:section:load', event => sync(event.target));
})();
